export class PremioAgrupadoModel {
  public valorPremioSorteio: number;
  public quantidade: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/premio-agrupado.model.ts